const pad = (n) => String(n).padStart(2, "0");
const MINUTES = Array.from({ length: 60 }, (_, i) => pad(i));
const selectCls = "h-11 px-2 border border-slate-200 rounded-lg bg-white text-sm font-semibold text-[#0F172A] focus:border-[#1E3A8A] focus:ring-1 focus:ring-[#1E3A8A] outline-none";

/** Time picker emitting "HH:MM" (24h). Shows 1-12 + AM/PM in 12-hour mode. */
export function TimeInput({ value, onChange, hour12, testId }) {
    const [h, m] = (value || "10:00").split(":").map(Number);
    const isPm = h >= 12;
    const emit = (hh, mm) => onChange(`${pad(hh)}:${pad(mm)}`);
    const set12 = (h12, pm) => emit((h12 % 12) + (pm ? 12 : 0), m);

    return (
        <div className="flex flex-wrap items-center gap-1.5" data-testid={testId}>
            {hour12 ? (
                <select aria-label="Hour" value={((h + 11) % 12) + 1} onChange={(e) => set12(+e.target.value, isPm)} data-testid={`${testId}-hour`} className={selectCls}>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => <option key={n} value={n}>{n}</option>)}
                </select>
            ) : (
                <select aria-label="Hour" value={h} onChange={(e) => emit(+e.target.value, m)} data-testid={`${testId}-hour`} className={selectCls}>
                    {Array.from({ length: 24 }, (_, i) => i).map((n) => <option key={n} value={n}>{pad(n)}</option>)}
                </select>
            )}
            <span className="font-bold text-slate-400">:</span>
            <select aria-label="Minute" value={pad(m)} onChange={(e) => emit(h, +e.target.value)} data-testid={`${testId}-minute`} className={selectCls}>
                {MINUTES.map((mm) => <option key={mm} value={mm}>{mm}</option>)}
            </select>
            {hour12 && (
                <div className="inline-flex rounded-lg border border-slate-200 overflow-hidden ml-1" role="group" aria-label="AM or PM">
                    {["AM", "PM"].map((label) => {
                        const active = (label === "PM") === isPm;
                        return (
                            <button key={label} type="button" onClick={() => set12(((h + 11) % 12) + 1, label === "PM")}
                                data-testid={`${testId}-${label.toLowerCase()}`} aria-pressed={active}
                                className={`h-11 px-3 text-xs font-bold transition-colors ${active ? "bg-[#1E3A8A] text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}>
                                {label}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
